import { EntityType } from "@mapmycustomers/shared";

import { EfficiencyTrackerCriteria } from "@app/types/dashboard/cards/efficiencyTracker/EfficiencyTrackerCardConfiguration";
import EntityTypesSupportedInEfficiencyTracker from "@app/types/dashboard/cards/efficiencyTracker/EntityTypesSupportedInEfficiencyTracker";
import ActivityFieldName from "@app/util/fieldModel/ActivityFieldName";
import CommonFieldName from "@app/util/fieldModel/CommonFieldName";
import CompanyFieldName from "@app/util/fieldModel/CompanyFieldName";
import DealFieldName from "@app/util/fieldModel/DealFieldName";
import PersonFieldName from "@app/util/fieldModel/PersonFieldName";

export interface EfficiencyDrillDownColumnConfig {
  columns: string[];
  sortColumn: string;
}

const baseColumnsByEntity: Record<EntityTypesSupportedInEfficiencyTracker, string[]> = {
  [EntityType.ACTIVITY]: [
    ActivityFieldName.PRIMARY_ASSOCIATION,
    ActivityFieldName.ACTIVITY_TYPE,
    ActivityFieldName.ASSIGNEE,
    ActivityFieldName.START_AT,
    ActivityFieldName.COMPLETED_AT,
    ActivityFieldName.NOTE,
  ],
  [EntityType.COMPANY]: [
    CompanyFieldName.NAME,
    CommonFieldName.USER,
    CompanyFieldName.ADDRESS,
    CommonFieldName.CREATED_AT,
    CommonFieldName.SOURCE,
  ],
  [EntityType.DEAL]: [
    DealFieldName.NAME,
    CommonFieldName.USER,
    DealFieldName.ADDRESS,
    CommonFieldName.CREATED_AT,
    CommonFieldName.SOURCE,
  ],
  [EntityType.PERSON]: [
    PersonFieldName.NAME,
    CommonFieldName.USER,
    PersonFieldName.ADDRESS,
    CommonFieldName.CREATED_AT,
    CommonFieldName.SOURCE,
  ],
};

const baseSortByEntity: Record<EntityTypesSupportedInEfficiencyTracker, string> = {
  [EntityType.ACTIVITY]: ActivityFieldName.COMPLETED_AT,
  [EntityType.COMPANY]: CommonFieldName.CREATED_AT,
  [EntityType.DEAL]: CommonFieldName.CREATED_AT,
  [EntityType.PERSON]: CommonFieldName.CREATED_AT,
};

const facetimeColumns: string[] = [
  ActivityFieldName.PRIMARY_ASSOCIATION,
  ActivityFieldName.ACTIVITY_TYPE,
  ActivityFieldName.ASSIGNEE,
  ActivityFieldName.COMPLETED_AT,
  ActivityFieldName.CHECK_IN_DISTANCE,
  ActivityFieldName.RELIABILITY,
  ActivityFieldName.NOTE,
];

const wonRevenueColumns: string[] = [
  DealFieldName.NAME,
  CommonFieldName.USER,
  DealFieldName.ADDRESS,
  DealFieldName.AMOUNT,
  CommonFieldName.CREATED_AT,
  CommonFieldName.SOURCE,
];

const getEfficiencyDrillDownColumnConfig = (
  criteria: Pick<EfficiencyTrackerCriteria, "entityType" | "fieldName" | "fieldType">,
  entityType: EntityTypesSupportedInEfficiencyTracker
): EfficiencyDrillDownColumnConfig => {
  if (criteria.fieldType === "facetime") {
    return { columns: facetimeColumns, sortColumn: ActivityFieldName.COMPLETED_AT };
  }
  if (criteria.fieldType === "wonRevenue") {
    return { columns: wonRevenueColumns, sortColumn: DealFieldName.CLOSING_DATE };
  }

  const columns = [...baseColumnsByEntity[entityType]];
  if (
    criteria.fieldType === "custom" &&
    criteria.fieldName &&
    !columns.includes(criteria.fieldName)
  ) {
    columns.push(criteria.fieldName);
  }
  return { columns, sortColumn: baseSortByEntity[entityType] };
};

export default getEfficiencyDrillDownColumnConfig;
